<template>
  <article class="filters-wrapper">
    <TimetableFilter
      v-for="filter in TIMETABLE_SELECTABLE_FILTER_KEYS"
      :id="filter"
      :key="filter"
      :value="filters[filter]"
      @change="onFilterChange"
    />
    <button
      v-if="isAnyFilterActive"
      class="clear-filters t-p-s-130"
      @click="emit('reset-filters-click')"
    >
      <CloserIcon /> {{ t('timetable.clear-filters') }}
    </button>
  </article>
</template>

<script lang="ts" setup>
import CloserIcon from '@/assets/icons/closer-icon.svg?component'
import type {
  TimetableFilterDict,
  TimetableFilterValue,
  TimetableSelectableFilterKey
} from '@/composables/useTimetableQuery'

const props = defineProps<{
  filters: TimetableFilterDict
}>()

const isSelectableEntry = <T,>([key]: [string, T]) =>
  TIMETABLE_SELECTABLE_FILTER_KEYS.includes(key as TimetableSelectableFilterKey)
const isTruthyEntry = <T,>([, value]: [string, T]) => !!value

const isAnyFilterActive = computed(() =>
  Object.entries(props.filters).filter(isSelectableEntry).some(isTruthyEntry)
)

const emit = defineEmits<{
  (event: 'reset-filters-click'): void
  (
    event: 'filter-change',
    id: TimetableSelectableFilterKey,
    value: TimetableFilterValue
  ): void
}>()
const { t } = useI18n()

const onFilterChange = (
  id: TimetableSelectableFilterKey,
  value: TimetableFilterValue
) => emit('filter-change', id, value)
</script>

<style lang="scss" scoped>
.filters-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: rem(8px);
  align-items: center;
  justify-content: center;
  margin-bottom: rem(32px);

  @include media-up(md) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include media-up(s-lg) {
    grid-template-columns: repeat(4, rem(184.75px)) 1fr;
  }

  @include media-up(lg) {
    grid-template-columns: repeat(4, rem(233.6px)) 1fr;
  }

  .clear-filters {
    display: flex;
    gap: rem(16px);
    align-items: center;
    height: rem(44px);
    padding-left: rem(18px);
    text-align: center;
    cursor: pointer;
  }
}
</style>
